import { getAge } from 'utils/date'
import useStore from 'stores/utils/hooks/useStore'
import { getAgeGroupFromAge } from 'utils/userState'

export function useAgeGroup() {
  const birthday = useStore(
    (store) => store.traversal.data.debtors.primary.personal.birthday
  )

  const debtorsAge = getAge(birthday)
  const ageGroup = getAgeGroupFromAge(debtorsAge)
  return ageGroup
}
